import { createContext, useContext, useState, useCallback } from "react";

const PageHeaderContext = createContext({
  headerContent: null,
  setHeaderContent: () => {},
});

export const PageHeaderProvider = ({ children }) => {
  const [headerContent, setHeaderContent] = useState(null);
  return (
    <PageHeaderContext.Provider value={{ headerContent, setHeaderContent }}>
      {children}
    </PageHeaderContext.Provider>
  );
};

export const usePageHeader = () => useContext(PageHeaderContext);
